<template>

    <!-- user welcome -->
    <div class="text-center mt-10">
      <p>
        <UserAvatar :size="isMobile ? 80 : 150"/>
      </p>
      <p class="text-h4 white--text font-weight-bold">
        {{ greetings }}, {{ user.firstname }}
      </p>
      <p v-if="settingsApp">
        <v-btn text color="info"
               @click="open(settingsApp)">
          Impostazioni account
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </p>
    </div>

</template>

<style lang="scss">
  
</style>

<script>
  import moment from 'moment'
  import { mapActions, mapGetters, mapMutations } from 'vuex'

  import utility from '@/mixins/utility'

  import UserAvatar from '@/components/UserAvatar'

   export default {
    
    name: 'DashboardWelcome',

    mixins: [ utility ],

    components:
    {
      UserAvatar
    },

    data: () => ({

    }),

    computed:
    {
      ...mapGetters({
        allMenus: 'menu/items',
        user: 'auth/user'
      }),

      settingsApp()
      {
        const settingsUrl = 'https://store.zwan.it/profile',
              menu = this.allMenus.filter((item)=>{
                  return item.url === settingsUrl
                }).shift()

        return menu
      },

      greetings()
      {
        const hours = moment().format('HH')
        // pomeriggio
        if( hours >= 12 && hours < 19 )
            return "Buon pomeriggio"
        // sera
        if( hours >= 19 && hours < 23 )
            return "Buonasera"
        // notte
        if( hours >= 23 && hours < 5 )
            return "Buonanotte"
        // default
        return "Buongiorno"
      }
    },

    methods:
    {
      ...mapActions({
        openApp: 'menu/open'
      }),

      ...mapMutations({
        setLoading: 'ui/setLoading'
      }),

      open(item)
      {
        if( !item.isOpen )
          this.setLoading('linear')

        this.openApp(item)
      }
    },

    load(){}
  }
</script>